import React, { useState } from 'react';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="hidden sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-brand-200/70 shadow-xs">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">

        {/* Logo matching the image */}
        <a href="#" className="flex items-center space-x-3 group">
          <div className="flex flex-col">
            <div className="flex items-center gap-1.5">
              <span className="font-serif text-3xl sm:text-4xl tracking-tight text-brand-800 font-bold group-hover:text-brand-600 transition-colors">
                DA'Vi
              </span>
              {/* Olive branch logo image */}
              <img
                src="/logo_small.png"
                alt="DA'Vi Olive Branch Logo"
                className="w-6 h-6 sm:w-7 sm:h-7 object-contain transform rotate-12 -mt-1"
              />

            </div>
            <span className="text-[9px] uppercase tracking-[0.25em] text-brand-600 font-semibold -mt-0.5">
              Greek Yogurt & Croissant
            </span>
          </div>
        </a>

        {/* Desktop Navigation matching the image */}
        <nav className="hidden lg:flex items-center space-x-9 text-[13px] tracking-[0.16em] uppercase font-semibold text-brand-800">
          <a href="#" className="hover:text-brand-500 transition-colors">
            Home
          </a>
          <a href="#menu" className="hover:text-brand-500 transition-colors">
            Menu
          </a>
          <a href="#about" className="hover:text-brand-500 transition-colors">
            Our Story
          </a>
          <a href="#popular" className="hover:text-brand-500 transition-colors">
            Popular Picks
          </a>
          <a href="#builder" className="hover:text-brand-500 transition-colors">
            DIY Bowl
          </a>
          <a href="#contact" className="hover:text-brand-500 transition-colors">
            Contact
          </a>
        </nav>

        {/* Right CTA Button */}
        <div className="flex items-center space-x-3">
          <a
            href="#builder"
            className="inline-flex items-center justify-center px-6 py-2.5 rounded-full text-xs font-semibold uppercase tracking-wider bg-brand-600 hover:bg-brand-700 text-white transition-all shadow-sm hover:shadow-md transform hover:-translate-y-0.5"
          >
            Order Now
          </a>

          {/* Mobile hamburger toggle */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 text-brand-800 hover:text-brand-600 focus:outline-none"
            aria-label="Toggle navigation"
          >
            <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'} text-lg`}></i>
          </button>
        </div>
      </div>

      {/* Mobile dropdown menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-b border-brand-200 px-6 py-5 space-y-3 shadow-lg">
          <a
            href="#"
            onClick={() => setMobileMenuOpen(false)}
            className="block text-xs uppercase tracking-widest font-semibold text-brand-800 py-2 hover:text-brand-500"
          >
            Home
          </a>
          <a
            href="#menu"
            onClick={() => setMobileMenuOpen(false)}
            className="block text-xs uppercase tracking-widest font-semibold text-brand-800 py-2 hover:text-brand-500"
          >
            Menu
          </a>
          <a
            href="#about"
            onClick={() => setMobileMenuOpen(false)}
            className="block text-xs uppercase tracking-widest font-semibold text-brand-800 py-2 hover:text-brand-500"
          >
            Our Story
          </a>
          <a
            href="#popular"
            onClick={() => setMobileMenuOpen(false)}
            className="block text-xs uppercase tracking-widest font-semibold text-brand-800 py-2 hover:text-brand-500"
          >
            Popular Picks
          </a>
          <a
            href="#builder"
            onClick={() => setMobileMenuOpen(false)}
            className="block text-xs uppercase tracking-widest font-semibold text-brand-800 py-2 hover:text-brand-500"
          >
            DIY Bowl
          </a>
          <a
            href="#contact"
            onClick={() => setMobileMenuOpen(false)}
            className="block text-xs uppercase tracking-widest font-semibold text-brand-800 py-2 hover:text-brand-500"
          >
            Contact
          </a>
        </div>
      )}
    </header>
  );
}

export default Header;
